import React from "react"
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Button, Link } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
    },
  })
)

export default function AlertExample() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Alert
        action={
          <Button color="inherit" size="small">
            hide
          </Button>
        }
        severity="error"
      >
        <AlertTitle>Error</AlertTitle>
        Please note that bulk deliveries are only possible currently for
        deliveries into Europe and other countries like UK, Norway etc that use
        the same bulk handling equipment.
        <Link href="#">Action Link</Link>
      </Alert>
      <Alert onClose={() => {}} variant="filled" severity="error">
        This is a filled error alert — <strong>check it out!</strong>
      </Alert>
      <Alert onClose={() => {}} severity="warning">
        This is a warning alert — <strong>check it out!</strong>
      </Alert>
      <Alert action severity="info">
        <AlertTitle>Info</AlertTitle>
        This is an info alert — <strong>check it out!</strong>
      </Alert>
      <Alert severity="success">
        <AlertTitle>Success</AlertTitle>
        This is a success alert — <strong>check it out!</strong>
      </Alert>
    </div>
  )
}
